export const AUTH_TOKEN = 'auth_token';
export const LOCALHOST = 'http://localhost:9092'
export const OBUKI = 'https://obuki.zdravstvo.gov.mk'